// Iconic International Cricket Moments

export const internationalMoments = [
  // World Cup Moments
  {
    id: 1,
    title: "India Wins 2011 World Cup",
    year: 2011,
    format: "ODI",
    event: "ICC Cricket World Cup Final",
    description: "MS Dhoni's iconic six at Wankhede Stadium ended India's 28-year World Cup drought. Sachin Tendulkar was finally a World Champion.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/319800/319833.jpg",
    players: ["MS Dhoni", "Sachin Tendulkar", "Gautam Gambhir"]
  },
  {
    id: 2,
    title: "India's First T20 World Cup",
    year: 2007,
    format: "T20I",
    event: "ICC T20 World Cup Final",
    description: "A young Indian team led by MS Dhoni defeated Pakistan in a thrilling final. Joginder Sharma's last over became legendary.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316700/316757.jpg",
    players: ["MS Dhoni", "Yuvraj Singh", "Irfan Pathan"]
  },
  {
    id: 3,
    title: "Kapil Dev's 175* vs Zimbabwe",
    year: 1983,
    format: "ODI",
    event: "ICC Cricket World Cup",
    description: "India was 17/5 when Kapil Dev played the innings of his life - 175* off 138 balls to save India's World Cup campaign.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316700/316747.jpg",
    players: ["Kapil Dev"]
  },
  {
    id: 4,
    title: "India Wins 1983 World Cup",
    year: 1983,
    format: "ODI",
    event: "ICC Cricket World Cup Final",
    description: "The underdogs defeated mighty West Indies at Lord's. Kapil Dev's catch to dismiss Viv Richards changed cricket forever.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316700/316746.jpg",
    players: ["Kapil Dev", "Mohinder Amarnath"]
  },
  {
    id: 5,
    title: "India Wins T20 World Cup 2024",
    year: 2024,
    format: "T20I",
    event: "ICC T20 World Cup Final",
    description: "Rohit Sharma led India to glory in Barbados. Virat Kohli's 76 and Bumrah's brilliance sealed the victory against South Africa.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/387400/387408.jpg",
    players: ["Rohit Sharma", "Virat Kohli", "Jasprit Bumrah"]
  },
  // Test Cricket Moments
  {
    id: 6,
    title: "Gabba Breach 2021",
    year: 2021,
    format: "Test",
    event: "Border-Gavaskar Trophy",
    description: "India's young guns broke Australia's 32-year unbeaten streak at the Gabba. Rishabh Pant's 89* sealed a historic series win.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/400100/400198.jpg",
    players: ["Rishabh Pant", "Shubman Gill", "Mohammed Siraj"]
  },
  {
    id: 7,
    title: "Kumble's 10 Wickets in an Innings",
    year: 1999,
    format: "Test",
    event: "India vs Pakistan",
    description: "Anil Kumble became only the second bowler in history to take all 10 wickets in a Test innings - 10/74 at Delhi.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316556.jpg",
    players: ["Anil Kumble"]
  },
  {
    id: 8,
    title: "VVS Laxman's 281 at Eden",
    year: 2001,
    format: "Test",
    event: "India vs Australia",
    description: "Following on, VVS Laxman scored 281 in partnership with Rahul Dravid's 180. India won after following on - only 3rd time in Test history.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316559.jpg",
    players: ["VVS Laxman", "Rahul Dravid"]
  },
  {
    id: 9,
    title: "Sachin's Desert Storm",
    year: 1998,
    format: "ODI",
    event: "Coca-Cola Cup Final",
    description: "In a sandstorm in Sharjah, Sachin Tendulkar scored 143 against Australia to take India to the final. One of cricket's greatest innings.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316555.jpg",
    players: ["Sachin Tendulkar"]
  },
  {
    id: 10,
    title: "Sachin's 100th International Century",
    year: 2012,
    format: "ODI",
    event: "Asia Cup",
    description: "Sachin Tendulkar became the only cricketer to score 100 international centuries - a record that may never be broken.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316555.jpg",
    players: ["Sachin Tendulkar"]
  },
  // Women's Cricket Moments
  {
    id: 11,
    title: "Harmanpreet's 171* at WWC",
    year: 2017,
    format: "ODI",
    event: "ICC Women's World Cup Semi-Final",
    description: "Harmanpreet Kaur played one of the greatest innings in women's cricket - 171* off 115 balls against Australia at Derby.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316586.jpg",
    players: ["Harmanpreet Kaur"]
  },
  {
    id: 12,
    title: "India Women in WWC 2017 Final",
    year: 2017,
    format: "ODI",
    event: "ICC Women's World Cup Final",
    description: "India reached their first-ever Women's World Cup Final at Lord's. Though they lost to England, women's cricket in India changed forever.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316583.jpg",
    players: ["Mithali Raj", "Harmanpreet Kaur", "Jhulan Goswami"]
  },
  {
    id: 13,
    title: "Jhulan's 200 ODI Wickets",
    year: 2018,
    format: "ODI",
    event: "India vs South Africa",
    description: "Jhulan Goswami became the first woman to take 200 ODI wickets. A milestone that cement her legacy as the greatest fast bowler.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316582.jpg",
    players: ["Jhulan Goswami"]
  },
  // IPL & Domestic Moments
  {
    id: 14,
    title: "Yuvraj's 6 Sixes",
    year: 2007,
    format: "T20I",
    event: "ICC T20 World Cup",
    description: "Yuvraj Singh hit Stuart Broad for 6 consecutive sixes in one over - the fastest fifty in T20 history (12 balls).",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316570.jpg",
    players: ["Yuvraj Singh"]
  },
  {
    id: 15,
    title: "Rohit's 264 - Highest ODI Score",
    year: 2014,
    format: "ODI",
    event: "India vs Sri Lanka",
    description: "Rohit Sharma scored 264 at Kolkata - the highest individual score in ODI history. He has 3 double centuries, no one else has more than 1.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316600/316604.jpg",
    players: ["Rohit Sharma"]
  },
  {
    id: 16,
    title: "Bumrah's Hat-trick",
    year: 2023,
    format: "Test",
    event: "India vs West Indies",
    description: "Jasprit Bumrah took a hat-trick in Tests, becoming only the third Indian pacer to achieve this feat.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316600/316603.jpg",
    players: ["Jasprit Bumrah"]
  },
  {
    id: 17,
    title: "SKY's 360° Century",
    year: 2022,
    format: "T20I",
    event: "India vs England",
    description: "Suryakumar Yadav scored 117 off 55 balls at Trent Bridge - one of the greatest T20I innings ever, hitting shots all around the ground.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316600/316607.jpg",
    players: ["Suryakumar Yadav"]
  },
  {
    id: 18,
    title: "Virat's 183 vs Pakistan",
    year: 2012,
    format: "ODI",
    event: "Asia Cup",
    description: "Virat Kohli chased down 330 with an unbeaten 183 against Pakistan - one of the greatest chases in cricket history.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316600/316605.jpg",
    players: ["Virat Kohli"]
  },
  {
    id: 19,
    title: "Dhoni Finishes Off in Style",
    year: 2011,
    format: "ODI",
    event: "ICC Cricket World Cup Final",
    description: "\"Dhoni finishes off in style! A magnificent strike into the crowd! India lift the World Cup after 28 years!\" - Ravi Shastri",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316576.jpg",
    players: ["MS Dhoni"]
  },
  {
    id: 20,
    title: "Women's Premier League Launch",
    year: 2023,
    format: "T20",
    event: "WPL Season 1",
    description: "The first season of WPL marked a new era for women's cricket in India with record viewership and participation.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316592.jpg",
    players: ["Smriti Mandhana", "Harmanpreet Kaur", "Shafali Verma"]
  },
  {
    id: 21,
    title: "Kohli's 50th ODI Century",
    year: 2023,
    format: "ODI",
    event: "ICC Cricket World Cup",
    description: "Virat Kohli surpassed Sachin Tendulkar's record of 49 ODI centuries with his 50th ton during the 2023 World Cup.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316600/316605.jpg",
    players: ["Virat Kohli"]
  },
  {
    id: 22,
    title: "Ashwin's 500 Test Wickets",
    year: 2024,
    format: "Test",
    event: "Border-Gavaskar Trophy",
    description: "Ravichandran Ashwin became only the 2nd Indian and 9th overall to take 500 Test wickets, cementing his legacy.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316600/316602.jpg",
    players: ["Ravichandran Ashwin"]
  },
  {
    id: 23,
    title: "Dravid's Wall at Lord's",
    year: 2011,
    format: "Test",
    event: "India vs England",
    description: "Rahul Dravid scored twin centuries at Lord's (103* and 146*) in a losing cause - but it showcased why he's called The Wall.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316558.jpg",
    players: ["Rahul Dravid"]
  },
  {
    id: 24,
    title: "Sehwag's Triple Century",
    year: 2004,
    format: "Test",
    event: "India vs Pakistan",
    description: "Virender Sehwag became the first Indian to score a Test triple century (309) - doing it against Pakistan in Pakistan.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316567.jpg",
    players: ["Virender Sehwag"]
  },
  {
    id: 25,
    title: "Ganguly's Jersey at Lord's",
    year: 2002,
    format: "ODI",
    event: "NatWest Series Final",
    description: "After Yuvraj and Kaif's heroics, Sourav Ganguly waved his jersey at Lord's balcony - one of cricket's most iconic celebrations.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316571.jpg",
    players: ["Sourav Ganguly", "Yuvraj Singh", "Mohammad Kaif"]
  },
  {
    id: 26,
    title: "Shami's 7-Wicket Haul",
    year: 2023,
    format: "ODI",
    event: "ICC Cricket World Cup",
    description: "Mohammed Shami took 7/57 against New Zealand in the semi-final - the best bowling figures in World Cup knockout matches.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316600/316606.jpg",
    players: ["Mohammed Shami"]
  },
  {
    id: 27,
    title: "India's U-19 World Cup Dominance",
    year: 2024,
    format: "ODI",
    event: "ICC U-19 World Cup",
    description: "India has won the U-19 World Cup a record 5 times, producing legends like Kohli, Yuvraj, and now a new generation of stars.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316700/316757.jpg",
    players: ["Virat Kohli", "Yuvraj Singh", "Shubman Gill"]
  },
  {
    id: 28,
    title: "Smriti's Record Partnership",
    year: 2024,
    format: "ODI",
    event: "India vs South Africa",
    description: "Smriti Mandhana and Shafali Verma put on a record opening partnership, showcasing the bright future of Indian women's cricket.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316592.jpg",
    players: ["Smriti Mandhana", "Shafali Verma"]
  },
  {
    id: 29,
    title: "Pant's Counter-Attack",
    year: 2022,
    format: "Test",
    event: "India vs England",
    description: "Rishabh Pant scored 146 off 111 balls at Edgbaston, playing reverse scoops and audacious shots against the world's best.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/400100/400198.jpg",
    players: ["Rishabh Pant"]
  },
  {
    id: 30,
    title: "Champions Trophy 2013",
    year: 2013,
    format: "ODI",
    event: "ICC Champions Trophy Final",
    description: "India defeated England in the final to win the Champions Trophy - MS Dhoni's third ICC trophy as captain.",
    image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/316500/316576.jpg",
    players: ["MS Dhoni", "Virat Kohli", "Shikhar Dhawan"]
  }
];


// Cricket Legends and Their Inspirational Journeys

export const cricketLegends = [
  {
    id: 1,
    name: "Virat Kohli",
    nickname: "King Kohli",
    country: "India",
    role: "Batsman",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/Virat_Kohli_portrait.jpg/250px-Virat_Kohli_portrait.jpg",
    born: "November 5, 1988",
    birthplace: "Delhi, India",
    family: "Married to Anushka Sharma (Bollywood actress), Daughter: Vamika (2021), Son: Akaay (2024)",
    debut: {
      odi: "August 18, 2008 vs Sri Lanka",
      test: "June 20, 2011 vs West Indies",
      t20i: "June 12, 2010 vs Zimbabwe"
    },
    records: [
      "Fastest to 8,000, 9,000, 10,000, 11,000, 12,000 ODI runs",
      "Most centuries in successful run chases (26)",
      "Only player to average 50+ in all three formats simultaneously",
      "Most runs in a single IPL season (973 in 2016)"
    ],
    stats: {
      tests: { matches: 113, runs: 8848, average: 48.88, centuries: 29 },
      odis: { matches: 292, runs: 13848, average: 58.07, centuries: 50 },
      t20is: { matches: 125, runs: 4008, average: 52.73, centuries: 1 }
    },
    journey: "Lost his father during a Ranji match at age 18 but continued playing the next day, scoring 90 runs. Rose from Delhi's gullies to become one of the greatest batsmen ever. His fitness transformation inspired a generation.",
    quote: "Self-belief and hard work will always earn you success.",
    achievements: ["ICC Cricketer of the Year (2017, 2018)", "Padma Shri (2017)", "Khel Ratna (2018)"],
    netWorth: "$127 Million"
  },
  {
    id: 2,
    name: "MS Dhoni",
    nickname: "Captain Cool / Thala",
    country: "India",
    role: "Wicketkeeper-Batsman",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Mahendra_Singh_Dhoni_January_2016.jpg/250px-Mahendra_Singh_Dhoni_January_2016.jpg",
    born: "July 7, 1981",
    birthplace: "Ranchi, Jharkhand",
    family: "Married to Sakshi Singh (2010), Daughter: Ziva (2015)",
    debut: {
      odi: "December 23, 2004 vs Bangladesh",
      test: "December 2, 2005 vs Sri Lanka",
      t20i: "December 1, 2006 vs South Africa"
    },
    records: [
      "Only captain to win all three ICC trophies (T20 WC 2007, ODI WC 2011, CT 2013)",
      "Most matches as Indian captain (332)",
      "Most stumpings in international cricket (195)",
      "Fastest stumping ever recorded (0.08 seconds)"
    ],
    stats: {
      tests: { matches: 90, runs: 4876, average: 38.09, centuries: 6 },
      odis: { matches: 350, runs: 10773, average: 50.57, centuries: 10 },
      t20is: { matches: 98, runs: 1617, average: 37.6, centuries: 0 }
    },
    journey: "Worked as a Train Ticket Collector (TTE) in Kharagpur before cricket. Rejected multiple times, his long hair and attacking style were initially mocked. Became India's most successful captain ever.",
    quote: "You don't play for revenge, you play for respect and pride.",
    achievements: ["Padma Bhushan (2018)", "Khel Ratna (2007)", "ICC ODI Player of the Year (2008, 2009)"],
    netWorth: "$200 Million"
  },
  {
    id: 3,
    name: "Rohit Sharma",
    nickname: "Hitman",
    country: "India",
    role: "Opening Batsman",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Rohit_Gurunath_Sharma.jpg/250px-Rohit_Gurunath_Sharma.jpg",
    born: "April 30, 1987",
    birthplace: "Nagpur, Maharashtra",
    family: "Married to Ritika Sajdeh (2015), Daughter: Samaira (2018)",
    debut: {
      odi: "June 23, 2007 vs Ireland",
      test: "November 6, 2013 vs West Indies",
      t20i: "September 19, 2007 vs England"
    },
    records: [
      "Only player with three ODI double centuries (264, 209, 208*)",
      "Highest individual ODI score (264 vs Sri Lanka)",
      "Most sixes in international cricket (600+)",
      "5 IPL titles as captain (most ever)"
    ],
    stats: {
      tests: { matches: 56, runs: 4137, average: 42.64, centuries: 12 },
      odis: { matches: 264, runs: 10866, average: 49.16, centuries: 31 },
      t20is: { matches: 159, runs: 4231, average: 32.32, centuries: 4 }
    },
    journey: "Grew up in a one-room house in Borivali, Mumbai. Traveled 2 hours daily for cricket practice. Was dropped multiple times before finding his role as opener in 2013. Now India's T20 World Cup winning captain (2024).",
    quote: "I don't think about records. I just want to contribute to my team's victory.",
    achievements: ["Khel Ratna (2020)", "Arjuna Award (2015)", "T20 World Cup Winner (2024)"],
    netWorth: "$45 Million"
  },
  {
    id: 4,
    name: "Sachin Tendulkar",
    nickname: "Master Blaster / God of Cricket",
    country: "India",
    role: "Batsman",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Sachin_Tendulkar.jpg/250px-Sachin_Tendulkar.jpg",
    born: "April 24, 1973",
    birthplace: "Mumbai, Maharashtra",
    family: "Married to Anjali Tendulkar (1995), Son: Arjun, Daughter: Sara",
    debut: {
      odi: "December 18, 1989 vs Pakistan",
      test: "November 15, 1989 vs Pakistan",
      t20i: "December 1, 2006 vs South Africa"
    },
    records: [
      "Most runs in international cricket (34,357)",
      "Most centuries in international cricket (100)",
      "First player to score ODI double century (200* vs SA)",
      "Most runs in World Cup history (2,278)"
    ],
    stats: {
      tests: { matches: 200, runs: 15921, average: 53.78, centuries: 51 },
      odis: { matches: 463, runs: 18426, average: 44.83, centuries: 49 },
      t20is: { matches: 1, runs: 10, average: 10.0, centuries: 0 }
    },
    journey: "Debuted at 16, became the youngest Test centurion. Carried India's hopes for 24 years. Finally won World Cup at home in 2011, carried on teammates' shoulders. The only sportsperson to receive Bharat Ratna while still active.",
    quote: "People throw stones at you and you convert them into milestones.",
    achievements: ["Bharat Ratna (2014)", "Padma Vibhushan (2008)", "Khel Ratna (1997)"],
    netWorth: "$170 Million"
  },
  {
    id: 5,
    name: "Smriti Mandhana",
    nickname: "Lady Tendulkar",
    country: "India",
    role: "Opening Batter",
    gender: "Female",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Ms._Smriti_Mandhana%2C_Arjun_Awardee_%28Cricket%29%2C_in_New_Delhi_on_July_16%2C_2019_%28cropped%29.jpg/250px-Ms._Smriti_Mandhana%2C_Arjun_Awardee_%28Cricket%29%2C_in_New_Delhi_on_July_16%2C_2019_%28cropped%29.jpg",
    born: "July 18, 1996",
    birthplace: "Mumbai, Maharashtra",
    family: "Single. Brother Shravan also played first-class cricket.",
    debut: {
      odi: "April 10, 2014 vs Bangladesh",
      test: "August 13, 2014 vs England",
      t20i: "October 1, 2013 vs Bangladesh"
    },
    records: [
      "Fastest Indian woman to 2000 ODI runs",
      "First Indian woman to score T20I century",
      "Joint-fastest T20I fifty (18 balls)",
      "Most runs in Women's T20 World Cup edition (167 in 2020)"
    ],
    stats: {
      tests: { matches: 7, runs: 669, average: 66.9, centuries: 2 },
      odis: { matches: 80, runs: 3438, average: 45.17, centuries: 8 },
      t20is: { matches: 108, runs: 2761, average: 27.61, centuries: 1 }
    },
    journey: "Started playing cricket at 4 years old with her brother. Her father took a loan to fund her training. Now the face of Indian women's cricket, she's inspiring millions of girls to take up the sport.",
    quote: "Dream big. If you fall, get up and dream bigger.",
    achievements: ["Arjuna Award (2018)", "ICC Women's Cricketer of the Year (2018)", "Rachael Heyhoe Flint Award (2018)"],
    netWorth: "$5 Million"
  },
  {
    id: 6,
    name: "Harmanpreet Kaur",
    nickname: "Harman",
    country: "India",
    role: "All-rounder",
    gender: "Female",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Harmanpreet_Kaur_2017_%28sq_cropped%29.jpg/250px-Harmanpreet_Kaur_2017_%28sq_cropped%29.jpg",
    born: "March 8, 1989",
    birthplace: "Moga, Punjab",
    family: "Single. Father is a basketball player, Mother was a volleyball player.",
    debut: {
      odi: "April 18, 2009 vs Pakistan",
      test: "August 13, 2014 vs England",
      t20i: "June 28, 2009 vs England"
    },
    records: [
      "Highest individual score in Women's World Cup (171* vs Australia 2017)",
      "First Indian to play 100 T20Is",
      "Most T20I wins as captain (female)",
      "First Indian woman to score T20I hundred in Australia"
    ],
    stats: {
      tests: { matches: 4, runs: 275, average: 55.0, centuries: 1 },
      odis: { matches: 130, runs: 3484, average: 34.49, centuries: 5 },
      t20is: { matches: 155, runs: 3074, average: 26.96, centuries: 1 }
    },
    journey: "From a small town in Punjab where girls playing cricket was frowned upon, to leading India in World Cups. Her 171* against Australia in 2017 WWC semi-final is considered one of the greatest innings ever.",
    quote: "Don't let anyone tell you that you can't do something. Prove them wrong.",
    achievements: ["Arjuna Award (2017)", "Padma Shri (2024)", "ICC Women's T20I Cricketer of Year (2018)"],
    netWorth: "$3 Million"
  },
  {
    id: 7,
    name: "Jasprit Bumrah",
    nickname: "Boom Boom Bumrah",
    country: "India",
    role: "Fast Bowler",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Jasprit_Bumrah_in_PMO_New_Delhi.jpg/250px-Jasprit_Bumrah_in_PMO_New_Delhi.jpg",
    born: "December 6, 1993",
    birthplace: "Ahmedabad, Gujarat",
    family: "Married to Sanjana Ganesan (sports presenter, 2021), Son: Angad (2023)",
    debut: {
      odi: "January 23, 2016 vs Australia",
      test: "January 5, 2018 vs South Africa",
      t20i: "January 26, 2016 vs Australia"
    },
    records: [
      "#1 ICC Test bowler ranking (2024)",
      "Best economy rate in T20 World Cups (min 20 wickets)",
      "Fastest Indian to 100 Test wickets",
      "Only Asian pacer to take 5-wicket hauls in SA, Eng, Aus"
    ],
    stats: {
      tests: { matches: 36, runs: 413, wickets: 159, average: 20.47 },
      odis: { matches: 89, wickets: 149, average: 23.44, economy: 4.63 },
      t20is: { matches: 70, wickets: 85, average: 17.74, economy: 6.27 }
    },
    journey: "Lost his father at 5 years old. His unusual bowling action was initially rejected by coaches. Self-taught through watching YouTube videos, his unique action is now considered unhittable at death overs.",
    quote: "Your background doesn't matter. Your actions define who you are.",
    achievements: ["ICC Men's Player of the Month (Multiple)", "World's #1 Test Bowler", "T20 WC Winner (2024)"],
    netWorth: "$14 Million"
  },
  {
    id: 8,
    name: "Mithali Raj",
    nickname: "Lady Sachin",
    country: "India",
    role: "Batter",
    gender: "Female",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Mithali_Raj_%28cropped%29.jpg/250px-Mithali_Raj_%28cropped%29.jpg",
    born: "December 3, 1982",
    birthplace: "Jodhpur, Rajasthan",
    family: "Single. Originally trained as a Bharatanatyam dancer.",
    debut: {
      odi: "June 26, 1999 vs Ireland",
      test: "January 14, 2002 vs England",
      t20i: "August 5, 2006 vs England"
    },
    records: [
      "Highest run-scorer in Women's ODI cricket (7,805 runs)",
      "Most matches as captain in Women's ODIs (155)",
      "Only woman to surpass 7,000 ODI runs",
      "First woman to complete 20 years in international cricket"
    ],
    stats: {
      tests: { matches: 12, runs: 699, average: 43.68, centuries: 1 },
      odis: { matches: 232, runs: 7805, average: 50.68, centuries: 7 },
      t20is: { matches: 89, runs: 2364, average: 37.52, centuries: 0 }
    },
    journey: "Started cricket at 10, chose it over classical dance. Played when women's cricket had no money or recognition. Pioneered women's cricket in India for 23 years, inspiring generations of women cricketers.",
    quote: "Records are meant to be broken. What matters is inspiring others.",
    achievements: ["Padma Shri (2015)", "Arjuna Award (2003)", "Khel Ratna (2021)"],
    netWorth: "$3 Million",
    retired: true
  },
  {
    id: 9,
    name: "Ravindra Jadeja",
    nickname: "Sir Jadeja",
    country: "India",
    role: "All-rounder",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Ravindra_Jadeja_in_2018.jpg/250px-Ravindra_Jadeja_in_2018.jpg",
    born: "December 6, 1988",
    birthplace: "Navagam-Khed, Gujarat",
    family: "Married to Rivaba Jadeja (BJP politician, 2016), Daughter: Nidhyana (2017)",
    debut: {
      odi: "February 8, 2009 vs Sri Lanka",
      test: "December 13, 2012 vs England",
      t20i: "February 10, 2009 vs Sri Lanka"
    },
    records: [
      "#1 ICC Test all-rounder ranking (multiple times)",
      "Only player with 250+ wickets and 3000+ runs in Tests for India",
      "Fastest fielder - most direct hit run-outs",
      "Most catches by a non-wicketkeeper in Tests for India"
    ],
    stats: {
      tests: { matches: 72, runs: 3122, wickets: 294, average: 36.03 },
      odis: { matches: 197, runs: 2756, wickets: 220, economy: 4.94 },
      t20is: { matches: 74, runs: 515, wickets: 54, economy: 7.12 }
    },
    journey: "Lost his mother at 17, almost gave up cricket due to financial struggles. His sword celebration became iconic. From a small village in Gujarat to becoming the world's best all-rounder.",
    quote: "Stay humble. Work hard. The results will follow.",
    achievements: ["Arjuna Award (2019)", "ICC Test Team of the Year (Multiple)", "World #1 All-rounder"],
    netWorth: "$25 Million"
  },
  {
    id: 10,
    name: "Shafali Verma",
    nickname: "Little Master",
    country: "India",
    role: "Opening Batter",
    gender: "Female",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Shafali_Verma_%2852269499557%29.jpg/250px-Shafali_Verma_%2852269499557%29.jpg",
    born: "January 28, 2004",
    birthplace: "Rohtak, Haryana",
    family: "Single. Father Sanjeev Verma runs a jewelry shop, was her first coach.",
    debut: {
      odi: "September 19, 2021 vs Australia",
      test: "June 16, 2021 vs England",
      t20i: "September 17, 2019 vs South Africa"
    },
    records: [
      "Youngest Indian to debut in T20I (15 years)",
      "Youngest Indian to score international fifty",
      "Youngest to reach #1 T20I batting ranking (16 years)",
      "Youngest Indian to score a Test century (17 years)"
    ],
    stats: {
      tests: { matches: 5, runs: 398, average: 44.22, centuries: 1 },
      odis: { matches: 27, runs: 520, average: 21.66, centuries: 0 },
      t20is: { matches: 63, runs: 1341, average: 22.35, centuries: 0 }
    },
    journey: "Her father disguised her as a boy to play cricket in Haryana where girls playing was not accepted. At 15, she was terrorizing international bowlers. Represents the fearless future of Indian cricket.",
    quote: "Age is just a number. If you have talent and work hard, anything is possible.",
    achievements: ["ICC Emerging Player of the Year nominee", "Youngest #1 T20I batter ever"],
    netWorth: "$500,000"
  },
  {
    id: 11,
    name: "Suryakumar Yadav",
    nickname: "SKY / Mr. 360",
    country: "India",
    role: "Batsman",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Suryakumar_Yadav_%281%29.jpg/250px-Suryakumar_Yadav_%281%29.jpg",
    born: "September 14, 1990",
    birthplace: "Mumbai, Maharashtra",
    family: "Married to Devisha Shetty (2016)",
    debut: {
      odi: "July 18, 2021 vs Sri Lanka",
      test: "Not played yet",
      t20i: "March 14, 2021 vs England"
    },
    records: [
      "Highest T20I rating ever (892 points)",
      "Most T20I runs in a calendar year (1,164 in 2022)",
      "Fastest Indian to 1000 T20I runs",
      "Best T20I strike rate among top run-scorers (170+)"
    ],
    stats: {
      tests: { matches: 0, runs: 0, average: 0, centuries: 0 },
      odis: { matches: 31, runs: 647, average: 28.13, centuries: 0 },
      t20is: { matches: 70, runs: 2546, average: 44.66, centuries: 4 }
    },
    journey: "Waited 7 years to get India call-up despite dominating domestic cricket. Was 30 when he debuted. His 360-degree hitting ability and calm demeanor made him the best T20 batsman in the world within 2 years.",
    quote: "Good things take time. Keep working, your time will come.",
    achievements: ["ICC T20I Cricketer of the Year (2022, 2023)", "World #1 T20I batsman", "T20 WC Winner (2024)"],
    netWorth: "$8 Million"
  },
  {
    id: 12,
    name: "Jhulan Goswami",
    nickname: "Chakdaha Express",
    country: "India",
    role: "Fast Bowler",
    gender: "Female",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Ms._Jhulan_Goswami%2C_in_2012_%28cropped%29.jpg/250px-Ms._Jhulan_Goswami%2C_in_2012_%28cropped%29.jpg",
    born: "November 25, 1982",
    birthplace: "Chakdaha, West Bengal",
    family: "Single. Inspired a Bollywood biopic 'Chakda Xpress' starring Anushka Sharma.",
    debut: {
      odi: "January 6, 2002 vs England",
      test: "January 14, 2002 vs England",
      t20i: "August 5, 2006 vs England"
    },
    records: [
      "Highest wicket-taker in Women's ODI history (255 wickets)",
      "First woman to take 200 ODI wickets",
      "Only woman to take 40+ Test wickets for India",
      "Most wickets in Women's World Cup history"
    ],
    stats: {
      tests: { matches: 12, wickets: 44, average: 17.36, bestInnings: "5/25" },
      odis: { matches: 204, wickets: 255, average: 22.04, economy: 3.33 },
      t20is: { matches: 68, wickets: 56, average: 18.66, economy: 5.45 }
    },
    journey: "From a small town where cricket facilities didn't exist, she cycled 20km daily for practice. Played for 20 years, revolutionizing fast bowling in women's cricket. A true pioneer who paved the way for women pacers.",
    quote: "Dream, believe, achieve. Nothing is impossible.",
    achievements: ["Padma Shri (2012)", "Arjuna Award (2010)", "ICC Women's Player of the Year (2007)"],
    netWorth: "$1.5 Million",
    retired: true
  }
];

export const womenCricketPathway = {
  title: "Women's Cricket Pathway in India",
  levels: [
    {
      level: "School & District Level",
      age: "10-14 years",
      description: "Join school cricket teams and district-level academies. Focus on fundamentals and passion for the game.",
      opportunities: ["School tournaments", "District selection trials", "State academy scouting"]
    },
    {
      level: "State U-19",
      age: "14-19 years",
      description: "Compete in state under-19 tournaments. This is where selectors identify future talent.",
      opportunities: ["State U-19 championships", "Zonal tournaments", "India U-19 trials"]
    },
    {
      level: "India U-19 / Challenger Trophy",
      age: "16-19 years",
      description: "National level age-group cricket. Top performers get fast-tracked to senior team.",
      opportunities: ["U-19 World Cup", "Challenger Trophy", "India A selection"]
    },
    {
      level: "Senior State Team",
      age: "18+",
      description: "Compete in Women's Senior One Day and T20 trophies against other states.",
      opportunities: ["Senior Women's One Day Trophy", "Senior Women's T20 Trophy"]
    },
    {
      level: "Women's Premier League (WPL)",
      age: "18+",
      description: "India's professional T20 league for women. Platform for national selection and global exposure.",
      opportunities: ["WPL contracts (₹10L - ₹2Cr)", "International scouts", "Brand endorsements"]
    },
    {
      level: "India A & Senior Team",
      age: "18+",
      description: "Represent India in Tests, ODIs, and T20Is. The ultimate goal.",
      opportunities: ["World Cups", "Asia Cup", "Commonwealth Games", "BCCI central contracts"]
    }
  ],
  keyContacts: [
    "BCCI Women's Wing - bcci.tv/women",
    "State Cricket Associations",
    "National Cricket Academy, Bangalore"
  ]
};
